import React from 'react'
import RightSide from '../components/common/rightSide';
import EditorPolicy from '../components/other/editorPolocy';


const EditorPolicyPage = () => {
    return (
        <>
            <div className='container-fluid mt-2'>
                <div className='row'>
                    {/* <div className='col-md-4'>
                        <RightSide />
                    </div> */}
                    <div className='col-md-12'>
                        <EditorPolicy />
                    </div>

                </div>
            </div>
        </>
    )
}

export default EditorPolicyPage;